import { getMemberId } from '@trello/authentication';
import { PersistentSharedState } from '@trello/shared-state';

export type Panel = 'activity' | 'planner' | 'rovo';

interface CardBackSharedState {
  activePanel: Panel | null;
  isPanelOpen: boolean;
}

const shouldOpenPanel = window.innerWidth > 600;

export const defaultCardBackSharedState: CardBackSharedState = {
  activePanel: 'activity',
  isPanelOpen: shouldOpenPanel,
};

export const cardBackSharedState = new PersistentSharedState(
  defaultCardBackSharedState,
  { storageKey: () => `cardBackState-${getMemberId() ?? 'anonymous'}` },
);
